import * as React from 'react';
import styled from 'styled-components';
import withStyles from '@material-ui/core/styles/withStyles';
import { graphql } from 'gatsby';

import EmailContactSales from '../components/EmailContactSales';
import Layout from '../components/Layout';

import ABCBinders from '../images/personal-loans/ABCBinders.svg';
import CloudLock from '../images/personal-loans/CloudLock.svg';
import GirlKeyLock from '../images/personal-loans/girlKeyLock.svg';
import GirlPhoneWallet from '../images/personal-loans/girlPhoneWallet.svg';
import HandMoneyBag from '../images/personal-loans/HandMoneyBag.svg';
import WheelchairGirlLaptop from '../images/personal-loans/wheelchairGirlLaptop.svg';
import circleYellowDollarSign from '../images/icons/circle-yellow-dollar-sign.png';
import creditCardsSplash from '../images/personal-loans/header-gradient.png';
import halfSectionGradient from '../images/personal-loans/halfSectionGradient.png';
import halfSectionWithPattern from '../images/personal-loans/halfSectionWithPattern.png';

import fullWidthSplitBgWhiteOrange from '../images/personal-loans/fullWidthSplitBgWhiteOrange.png';

import WantToSeeHow from '../components/WantToSeeHow';
import leafImage from '../images/home/phoneLeaf.png';

import PhonePlayer from '../components/PhonePlayer';
import PhoneVideoMP4 from '../videos/pl.mp4';
import PhoneVideoWEBM from '../videos/pl.webm';
import posVideoThumbnail from '../images/phone/pl.png';

const styles = { paper: { margin: '1em', }, };

const Section = styled.section`

	&.full-width-split figure {
		background-color: #e2b667;
		background-image: ${(props) => `url('${halfSectionWithPattern}')`};

		@media (${(props) => props.theme.mediumUp}) {
			background-image: ${(props) => `url('${halfSectionGradient}')`};
		}

		& img {
			width: 135px;
			height: 282px;

			@media (${(props) => props.theme.smallUp}) {
				width: 236px;
				height: 481px;
			}

			@media (${(props) => props.theme.mediumUp}) {
				width: 200px;
				height: 418px;
			}

			@media (${(props) => props.theme.largeUp}) {
				width: 236px;
				height: 481px;
			}
		}

		& .decorationBehindPhone {
			background-image: ${(props) => `url('${leafImage}')`};
			background-repeat: no-repeat;
			background-position: left 70%;
			padding: 0 9%;
			background-size: 56px 92px;

			@media (${(props) => props.theme.smallUp}) {
				margin-left: 1em;
				padding: 0 15%;
				background-size: 113px 184px;
			}

			@media (${(props) => props.theme.mediumUp}) {
				padding: 0 0 0 15%;
				margin-left: 1em;
				background-size: 90px 147px;
			}

			@media (${(props) => props.theme.largeUp}) {
				padding: 0 0 0 17%;
				background-size: 113px 184px;
			}
		}
	}

	@media (${(props) => props.theme.mediumUp}) {
		&.whiteLeftOrangeRight {
			background-image: ${(props) => `url('${fullWidthSplitBgWhiteOrange}')`};
		}
	}
`;

const HeaderContentArticle = styled.article`
	color: white;

	& h1 {
		background-image: none;

		@media (${(props) => props.theme.mediumUp}) {
			background-image: ${(props) => `url('${circleYellowDollarSign}')`};
			background-repeat: no-repeat;
			background-position: right center;
			width: 270px;
		}

		@media (${(props) => props.theme.largeUp}) {
			width: 320px;
		}
	}
`;

const HeaderBottomContentFigure = styled.figure`
	background: transparent;
	margin-bottom: 1em;
`;

interface CreditCardsProps {
	classes: Record<string, any>;
	data: any;
}

interface CreditCardsState {
	isDialogOpen: boolean;
}

class PersonalLoansPage extends React.Component<CreditCardsProps, CreditCardsState> {
	state = {
		isDialogOpen: false,
	};

	closeDialog = () => {
		this.setState({ isDialogOpen: false });
	}

	watchVideo = () => {
		this.setState({ isDialogOpen: true });
	}

	render () {
		const {
			classes,
			data,
			data: {
				site: {
					siteMetadata: { endpoint },
				},
			},
		} = this.props;

		const creditCardsHeaderContent =
			<HeaderContentArticle>
				<h1>Personal<br />Loans</h1>
				<p className='bigger'>Make lending simple<br />with digital automation.</p>
				<EmailContactSales />
			</HeaderContentArticle>
		;

		const wheelchairGirlLaptopFigure =
			<HeaderBottomContentFigure>
				<WheelchairGirlLaptop alt='Girl in wheelchair with laptop, applying for a loan' />
			</HeaderBottomContentFigure>
		;

		return <Layout
			headerBottomContent={wheelchairGirlLaptopFigure}
			headerContent={creditCardsHeaderContent}
			headerSplashBg={creditCardsSplash}
			headerSplashBgAverageColor={'#e2b667'}
			metaDescription={"MK Decision's personal loan origination system streamlines online lending for financial institutions."}
			pageTitle={'Personal loan origination | PLOS | cost effective lending solutions'}
			skipMoney2020={true}
			BodyClass={'plos UseCases'}
		>
			<div className='centeredWrapper'>
				<Section className='centered-text'>
					<h2>Offer custom loan terms and rates online with Personal Loans</h2>
					{/* <h3>Confidently provide consumers fast financing for debt consolidation, medical bill repayment, student debts, and big-ticket purchases.</h3> */}
				</Section>
				<Section className='go-mobile row row-flush centered'>
					<article className='col-12 col-md-6 right-on-desktop'>
						<div className='text-box'>
							<header>
								<HandMoneyBag alt='Money bag' />
								<h2>Join the rapidly growing<br />personal loan market</h2>
							</header>
							<p>With a low 3.51% delinquency rate, $7,986 average debt per borrower, and over 19 million personal loans, the market has grown almost 15% in the last year. Deploy MK's Pre-Qualify technology today to increase personal loan conversions. There’s never been a wiser time for financial institutions to offer personal loans.</p>
						</div>
					</article>
					<figure className='col-12 col-md-6 left-on-desktop'>
						<GirlPhoneWallet alt='Girl with phone, money deposited into wallet' />
					</figure>
				</Section>
			</div>
			<Section className='full-width-split full-width whiteLeftOrangeRight'>
				<div className='centeredWrapper'>
					<div className='responsivePadding row row-flush'>
						<article className='col-12 col-md-6 left-on-desktop'>
							<div className='text-box'>
								<header>
									<ABCBinders alt='ABC Binders' />
									<h2>Build trust by educating<br />and informing your borrowers</h2>
								</header>
								<p>As more borrowers shop for personal loans online, information transparency will help you stand out from other lenders. MK's carefully crafted marketing web pages build rapport with your borrowers. Our job is to help you deliver important loan details in an intuitive and comprehensive way.</p>
							</div>
						</article>
						<figure className='col-12 col-md-6 right-on-desktop'>
							<PhonePlayer
								PhoneVideoMP4={PhoneVideoMP4}
								PhoneVideoWEBM={PhoneVideoWEBM}
							/>
						</figure>
					</div>
				</div>
			</Section>
			<div className='centeredWrapper'>
				<Section className='leverage-scalable row row-flush centered'>
					<article className='col-12 col-md-6 right-on-desktop'>
						<div className='text-box'>
							<header>
								<CloudLock alt='Secure Cloud' />
								<h2>Leverage scalable cloud<br />infrastructure for cyber security</h2>
							</header>
							<p>With MK's PLOS lending platform, your personal loan data will be stored in your private Amazon Web Services (AWS) cloud account. Prevent cybersecurity issues with AWS just like the US Department of Defense. Ensure durable, cost-effective backup, disaster recovery, and data archiving at petabyte scale.</p>
						</div>
					</article>
					<figure className='col-12 col-md-6 left-on-desktop'>
						<GirlKeyLock alt='Loan officer with key to secure cloud' />
					</figure>
				</Section>
				<WantToSeeHow />
			</div>
		</Layout>;
	}
}

export default withStyles(styles)(PersonalLoansPage);

export const pageQuery = graphql`
	query {
		site: site {
			siteMetadata {
				endpoint
			}
		}
  	}
`;
